import { C } from '../theme'
import { Reveal, RevealStagger } from './Reveal'
import { WhatsAppIcon } from './icons'
import { useContent } from '../content/ContentContext'
import { socialLinks } from '../content/socialLinks'
import { mediaAlt, mediaUrl } from '../content/derive'

export function Social() {
  const { home, settings } = useContent()
  const section = home.socialSection ?? {}
  const pills = socialLinks(settings)
  const posts = section.posts ?? []
  const whatsappGroup = settings.social?.whatsappGroup

  return (
    <section id="redes" aria-label="Redes sociales" className="sec" style={{ padding: '100px 40px 104px', background: 'linear-gradient(180deg,#faf6ef,#f1e9da)' }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <Reveal style={{ textAlign: 'center', maxWidth: 720, margin: '0 auto 30px' }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.red, marginBottom: 18 }}>{section.eyebrow}</div>
          <h2 className="section-title" style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 46, lineHeight: 1.08, margin: '0 0 8px', color: C.ink, letterSpacing: '-.01em' }}>
            {section.title}
          </h2>
          <p style={{ fontFamily: "'Spectral',serif", fontStyle: 'italic', fontSize: 17, color: C.muted, margin: 0 }}>
            {section.subtitle}
          </p>
        </Reveal>

        {pills.length > 0 && (
          <Reveal style={{ display: 'flex', flexWrap: 'wrap', gap: 13, justifyContent: 'center', margin: '0 0 44px' }}>
            {pills.map(({ href, display, label, Icon, bg, shadow }) => (
              <a key={label} className="pill" href={href} target="_blank" rel="noopener" style={{ display: 'inline-flex', alignItems: 'center', gap: 9, background: bg, color: '#fff', fontWeight: 700, fontSize: 14.5, padding: '12px 20px', borderRadius: 40, textDecoration: 'none', boxShadow: `0 8px 20px ${shadow}` }}>
                <Icon size={18} /> {display}
              </a>
            ))}
          </Reveal>
        )}

        {posts.length > 0 && (
          <RevealStagger className="ig-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 14 }}>
            {posts.map((post, i) => {
              const url = mediaUrl(post.image)
              if (!url) return null
              return (
                <div key={post.id ?? i} className="ig-tile" style={{ position: 'relative', overflow: 'hidden', borderRadius: 14, aspectRatio: '1 / 1', boxShadow: '0 10px 26px rgba(21,35,63,.08)' }}>
                  <img src={url} alt={mediaAlt(post.image, post.alt)} className="ig-img" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, padding: 14, background: 'linear-gradient(180deg,transparent,rgba(21,35,63,.72))', color: '#fff', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 7 }}>
                    <span style={{ color: C.red }}>♥</span> {post.likes ?? 0}
                  </div>
                </div>
              )
            })}
          </RevealStagger>
        )}

        {whatsappGroup && (
          <Reveal style={{ marginTop: 46, background: '#25D366', borderRadius: 18, padding: '30px 36px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap', boxShadow: '0 16px 40px rgba(37,211,102,.3)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#fff', color: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }}>
                <WhatsAppIcon size={30} />
              </div>
              <div>
                <div style={{ fontFamily: "'Spectral',serif", fontSize: 24, color: '#fff' }}>{section.whatsappTitle}</div>
                <div style={{ fontSize: 14.5, color: '#dbe4f5', opacity: 0.95 }}>{section.whatsappText}</div>
              </div>
            </div>
            {section.whatsappCtaLabel && (
              <a className="btn" href={whatsappGroup} target="_blank" rel="noopener" style={{ background: '#0b3d23', color: '#fff', fontWeight: 700, fontSize: 15, padding: '15px 30px', borderRadius: 40, textDecoration: 'none', whiteSpace: 'nowrap' }}>
                {section.whatsappCtaLabel}
              </a>
            )}
          </Reveal>
        )}
      </div>
    </section>
  )
}
